// src/components/PowerUsersTab.js
import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { fetchPowerUsersData } from './DataFlow';

const PowerUsersTab = () => {
    const [powerUsersData, setPowerUsersData] = useState([]);
    const [powerUsersRows, setPowerUsersRows] = useState(5);
    const [powerUsersFirst, setPowerUsersFirst] = useState(0);

    useEffect(() => {
        fetchPowerUsersData(setPowerUsersData);
    }, [powerUsersFirst, powerUsersRows]);

    const onPowerUsersPageChange = (e) => {
        setPowerUsersFirst(e.first);
        setPowerUsersRows(e.rows);
    };

    return (
        <DataTable
            value={powerUsersData}
            first={powerUsersFirst}
            paginator
            rows={powerUsersRows}
            onPage={onPowerUsersPageChange}
            rowsPerPageOptions={[5, 10, 20]}
            className="dark-table"
        >
            <Column field="email" header="Email" />
        </DataTable>
    );
};

export default PowerUsersTab;
